import React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

const SendIcon = () => {
	return (
		<Svg width="13" height="16" viewBox="0 0 13 16" fill="none">
			<Path
				d="M0.494 0.938737L12.802 7.70807C12.8543 7.73685 12.8978 7.77912 12.9282 7.83048C12.9586 7.88184 12.9746 7.94041 12.9746 8.00007C12.9746 8.05973 12.9586 8.1183 12.9282 8.16966C12.8978 8.22102 12.8543 8.2633 12.802 8.29207L0.494 15.0614C0.443249 15.0893 0.386099 15.1035 0.328182 15.1026C0.270265 15.1017 0.213582 15.0858 0.163718 15.0563C0.113854 15.0268 0.072531 14.9849 0.0438223 14.9346C0.0151136 14.8842 9.91698e-06 14.8273 0 14.7694V1.23074C9.91698e-06 1.17281 0.0151136 1.11589 0.0438223 1.06558C0.072531 1.01528 0.113854 0.973316 0.163718 0.943842C0.213582 0.914368 0.270265 0.898396 0.328182 0.897501C0.386099 0.896606 0.443249 0.910818 0.494 0.938737ZM1.33333 8.66674V13.0781L10.5667 8.00007L1.33333 2.92207V7.3334H4.66667V8.66674H1.33333Z"
				fill="#7C889B"
			/>
		</Svg>
	);
};

export default SendIcon;
